import React from "react";
import Gallery from "./Gallery";
import vsg1 from '../../assets/images/photos/vs-1.jpg'
import vsg2 from '../../assets/images/photos/vs-2.jpg'
import vsg3 from '../../assets/images/photos/vs-3.jpg'

const Photos = () => {


    const photoGallery = [
        { image: vsg1, name: 1 },
        { image: vsg2, name: 2 },
        { image: vsg3, name: 3 }
    ]

    return (
        <div className="mt-24">
            <h2 className="font-title text-center text-4xl font-bold tracking-wide text-secondary">GALERÍA DE FOTOS</h2>
            <Gallery photoGallery={photoGallery} />
        </div>
    );

}

export default Photos;